/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import { useState } from 'react';

/**
 * Custom useContractServices hook.
 * @returns {{showAll: boolean, handleShowMoreClick: handleShowMoreClick}}
 */
export function useContractServices() {
  const [showAll, setShowAll] = useState(false);

  /**
     * Click Handler
     */
  const handleShowMoreClick = () => {
    setShowAll((prevShowAll) => !prevShowAll);
  };

  return {
    showAll,
    handleShowMoreClick,
  };
}
